import { useEntity } from '@backstage/plugin-catalog-react';
import { InfoCard } from '@backstage/core-components';
import { Box, Chip, Tooltip, Typography, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  empty: {
    color: theme.palette.text.secondary,
  },
  chipContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(0.5),
    margin: 0,
    padding: 0,
  },
  chip: {
    height: 24,
  },
  chipKey: {
    fontWeight: 600,
  },
}));

export const EntityLabelsCard = () => {
  const classes = useStyles();
  const { entity } = useEntity();
  const labels = entity?.metadata?.labels ?? {};
  const entries = Object.entries(labels);

  if (entries.length === 0) {
    return null;
  }

  return (
    <InfoCard title="Labels">
      <Box className={classes.chipContainer} component="ul">
        {entries.map(([key, value]) => (
          <li key={key} style={{ listStyle: 'none' }}>
            <Tooltip title={`${key}: ${value}`} arrow>
              <Chip
                size="small"
                variant="outlined"
                className={classes.chip}
                label={
                  <Typography variant="caption">
                    <span className={classes.chipKey}>{key}</span>
                    {': '}
                    {value}
                  </Typography>
                }
              />
            </Tooltip>
          </li>
        ))}
      </Box>
    </InfoCard>
  );
};
